import React from 'react';
import SimulationDateLabels from "./SimulationBaseTableParts/SimulationDateLabels";
import SimulationTableHead from "./SimulationBaseTableParts/SimulationTableHead";
import SimulationTableColumnItems from "./SimulationBaseTableParts/SimulationTableColumnItems";
import {PitchCellName, PitchCellNumber, PitchCellTeam} from "./SimulationBaseTableParts/PitchCells_1";
import {FirstGame} from "./SimulationBaseTableParts/FirstGame";
import AnotherGame from "./SimulationBaseTableParts/AnotherGame";
import {SimulationData} from "../simulationTypes";
import {RuleType} from "../RuleType";
import {clearPitch, createBlankData, randomStr} from "../simulationFunctions";

type Props = {
  dateStr: string;
  setDateStr: React.Dispatch<React.SetStateAction<string>>;
  dateList: string[];
  setDateList: React.Dispatch<React.SetStateAction<string[]>>;
  simulations: SimulationData[];
  setSimulations: React.Dispatch<React.SetStateAction<SimulationData[]>>;
  rule: RuleType;
}

export const SimulationBaseTable: React.VFC<Props> = (props) => {

  return (
    <div className='overflow-x-auto px-5'>
      <SimulationDateLabels dateStr={props.dateStr} setDateStr={props.setDateStr} setDateList={props.setDateList}/>

      <table className='table-fixed'>
        <thead className="bg-blue-200">
        <SimulationTableHead dateList={props.dateList} />
        <SimulationTableColumnItems />
        {props.simulations.map((simulation, index) => {
          return(
            <tr id={simulation.id}  className={'border border-gray-500 ' + (index%2 === 1 ? 'bg-white':'bg-gray-200')}>
              <PitchCellName simulation={simulation} simulations={props.simulations} setSimulations={props.setSimulations} />
              <PitchCellTeam simulation={simulation} simulations={props.simulations} setSimulations={props.setSimulations} />
              <PitchCellNumber simulation={simulation} simulations={props.simulations} setSimulations={props.setSimulations} />
              <FirstGame simulation={simulation} simulations={props.simulations} setSimulations={props.setSimulations} rule={props.rule}/>
              <AnotherGame simulation={simulation} simulations={props.simulations} setSimulations={props.setSimulations} targetDay={1} targetResult={simulation.oneDayAfter} rule={props.rule} />
              <AnotherGame simulation={simulation} simulations={props.simulations} setSimulations={props.setSimulations} targetDay={2} targetResult={simulation.twoDaysAfter} rule={props.rule} />
              <AnotherGame simulation={simulation} simulations={props.simulations} setSimulations={props.setSimulations} targetDay={3} targetResult={simulation.threeDaysAfter} rule={props.rule} />
              <td className='inline-block whitespace-nowrap'>
                <button
                  className='py-1 px-2 my-1 mx-2 bg-gray-100 rounded font-bold border border-gray-400'
                  onClick={()=>{
                    const newList = clearPitch(simulation.id, props.simulations, props.rule);
                    props.setSimulations([...newList]);
                  }}
                >
                  球数クリア
                </button>
                <button
                  className='py-1 px-2 my-1 mx-2 bg-gray-100 rounded font-bold border border-gray-400'
                  onClick={()=>{
                    const newList = props.simulations.filter(simulationData => simulationData.id !== simulation.id);
                    props.setSimulations([...newList]);
                  }}
                >
                  消去
                </button>
              </td>
            </tr>
          );
        })}
        </thead>
      </table>
      <button
        className='py-2 px-4 my-4 mx-4 bg-gray-200 rounded-md font-bold'
        onClick={() => {
          const newSimulationData = createBlankData(randomStr(12), props.rule);
          props.setSimulations([...props.simulations, newSimulationData]);
        }}
      >枠の追加</button>
    </div>
  );
}
